"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LogLevel", {
  enumerable: true,
  get: function get() {
    return _contracts.LogLevel;
  }
});
exports.getLogger = getLogger;
exports.getLoggerBuilder = getLoggerBuilder;
var _ConsoleLogger = require("./ConsoleLogger");
var _LoggerBuilder = require("./LoggerBuilder");
var _contracts = require("./contracts");
/**
 * Build a customized logger instance
 */
function getLoggerBuilder() {
  return new _LoggerBuilder.LoggerBuilder(_ConsoleLogger.buildConsoleLogger);
}

/**
 * Get a default logger instance without any configuration
 */
function getLogger() {
  return getLoggerBuilder().build();
}
//# sourceMappingURL=index.js.map